<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="月份" prop="monthStart" style="width: 50%;">
                <el-date-picker v-model="q.monthStart" clearable type="month" value-format="yyyy-MM">
                </el-date-picker>
                <span class="w-time-to">至</span>
                <el-date-picker v-model="q.monthEnd" clearable type="month" value-format="yyyy-MM">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="省区" prop="areaCode">
                <brselect
                    category="YLRegion"
                    :v="q.areaCode"
                    v-model="q.areaCode"
                    :multiple="true"
                    :clearable="true"
                />
              </el-form-item>
            </div>
            <div class="l-screenBox">
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table ref="ddtable"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="530"
        >
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="省区"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: center;">{{ scope.row.area }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="targetCount"
              :show-overflow-tooltip="true"
              label="签约网络个数"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">{{ scope.row.targetCount!=null?scope.row.targetCount:0 }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="targetAmount"
              :show-overflow-tooltip="true"
              label="签约额（万元）"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">{{ Number(scope.row.targetAmount!=null?scope.row.targetAmount:0).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="50%达标" :show-overflow-tooltip="true">
            <el-table-column
                prop="fiftyCount"
                :show-overflow-tooltip="true"
                label="个数"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.fiftyCount!=null?scope.row.fiftyCount:0 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fiftyAmount"
                :show-overflow-tooltip="true"
                label="履约额（万元）"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fiftyAmount!=null?scope.row.fiftyAmount:0).toFixed(2) }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="70%达标" :show-overflow-tooltip="true">
            <el-table-column
                prop="seventyCount"
                :show-overflow-tooltip="true"
                label="个数"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.seventyCount!=null?scope.row.seventyCount:0 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="seventyAmount"
                :show-overflow-tooltip="true"
                label="履约额（万元）"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.seventyAmount!=null?scope.row.seventyAmount:0).toFixed(2) }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="100%达标" :show-overflow-tooltip="true">
            <el-table-column
                prop="hundredCount"
                :show-overflow-tooltip="true"
                label="个数"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ scope.row.hundredCount!=null?scope.row.hundredCount:0 }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="hundredAmount"
                :show-overflow-tooltip="true"
                label="履约额（万元）"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.hundredAmount!=null?scope.row.hundredAmount:0).toFixed(2) }}</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        monthStart: '',
        monthEnd: '',
        areaCode: null,
        pageSize: 50,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
    }
  },
  created() {
    this.q = {
      monthStart: this.getYearMonth(),
      monthEnd: this.getYearMonth(),
      province: null,
      pageSize: 50,
      pageNo: 1,
      total: 0
    };
  },
  mounted() {
    // 在mounted中调用，确保DOM已渲染完成
    this.$nextTick(() => {
      this.handleFilter();
    });
  },
  methods: {
    // 检索
    handleFilter() {
      this.q.pageNo = 1;
      this.query();
    },
    // 重置
    reset() {
      this.q = {
        monthStart: '',
        monthEnd: '',
        province: null,
        pageSize: this.q.pageSize,
        pageNo: 1,
        total: 0
      };
      this.handleFilter();
    },
    // 查询
    query() {
      console.log('rucan',this.q);
      ss.fanli.networkCompliancePage(this.q).then(res => {
        console.log('networkPage',res);
        this.tableData = res.records || [];
        this.q.total = res.total || 0;
      })
    },
    getYearMonth(){
      let now = new Date();
      let lastMonth = new Date(now);
      lastMonth.setMonth(now.getMonth()-1);
      let year = lastMonth.getFullYear();
      let month = lastMonth.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      return year + '-' + month;
    },
    //明细导出
    exportExcel() {

      updownfile.down("/api/swyl/v1/fl/networkCompliance/downloadExcel",this.q,"get",'params');

    },
  }
}
</script>

<style scoped>
.network-report-container {
  padding: 20px;
}
.query-form {
  margin-bottom: 20px;
}
</style>
